<template>
  <div class="hero">
    <div class="container">
      <div class="hero__wrapper">
        <div class="hero__left">
          <h1 class="hero__title">{{ t('home.hero.title') }}</h1>
          <p class="hero__subtitle">{{ t('home.hero.subtitle') }}</p>
          <p class="hero__text">{{ t('home.hero.text') }}</p>
          <div class="hero__buttons">
            <router-link :to="translations.i18nRoute({ name: 'market' })">
              {{ t('buttons.startShopping') }}
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
                <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#01AC1B" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </router-link>
            <button @click="scroll('categories')">
              {{ t('buttons.viewCategories') }}
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
                <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {scroll} from "@/core/helpers/scrollTo.js";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.hero {
  padding-block: 75px;

  &__wrapper {
    display: flex;
    justify-content: flex-end;
    border-radius: 16px;
    background-size: cover !important;
    background-image: url(@images/heroBg.png);
    background-repeat: no-repeat;
    background-position: center;
  }

  &__left {
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 60px 130px;
    background-image: url(@images/heroShadow.png);
    background-position: center;
  }

  &__image {
    width: 550px;
  }

  &__title {
    text-align: right;
    color: $white;
    font-size: 63px;
    font-weight: 700;
    line-height: 51px;
  }

  &__subtitle {
    margin-top: 10px;
    text-align: right;
    color: $white;
    font-size: 30px;
    font-weight: 600;
    line-height: 51px;
  }

  &__text {
    margin-block: 70px 25px;
    color: $white;
    font-family: "Hanken Grotesk", sans-serif;
    font-size: 18.5px;
    font-weight: 200;
    line-height: 30px;
  }

  &__buttons {
    display: flex;
    align-items: center;
    gap: 13px;

    & button, a {
      cursor: pointer;
      border-radius: 27px;
      border: 1px solid #fff;
      background-color: transparent;
      padding: 9px 20px;
      display: flex;
      align-items: center;
      transition: 0.2s;

      color: #fff;
      font-size: 21px;
      font-weight: 500;
      line-height: 27px;

      &:first-child {
        background-color: $white;
        color: #222;

        @include hover {
          background-color: transparent;
          color: #fff;
        }
      }

      @include hover {
        background-color: $white;
        color: #222;
      }
    }
  }
}

@media (max-width: 1300px) {
  .hero {
    &__left {
      padding: 40px;
    }

    &__title {
      font-size: 42px;
    }

    &__subtitle {
      margin-top: 0;
      font-size: 24px;
    }

    &__text {
      margin-block: 50px 15px;
    }

    &__image {
      width: 350px;
    }
  }
}

@media (max-width: 1000px) {
  .hero {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      //background: linear-gradient(97deg, #212844 36.55%, #236499 108.66%);
    }
  }
}

@media (max-width: 650px) {
  .hero {
    &__buttons {
      flex-direction: column;
      gap: 10px;
    }
  }
}
</style>